<template>
    <div v-show="store.state.currentTab === 'Upgrade'" class="b3-menu-content">
        <h1 class="themed-title">Updating</h1>
        <div>Welcome to Beadographer 3. Beadographer now stores your projects in the cloud.</div>
        <div>Your projects are being uploaded to the cloud...</div>

        <h2>Back up</h2>
        <div>Please click this button to save a backup of your projects.</div>
        <button @click="doBackup">Back up</button>

        <div class="log-area">
            <h2>Update log</h2>
            <div v-for="(item, i) in store.state.upgradeLog">{{ item }}</div>
        </div>
    </div>
</template>

<script>
import { doBackup } from '../../myapp/src/procedures/migrate';

export default {
    methods: {
        doBackup
    }
}
</script>

<style lang="scss">
.log-area {
    margin-top: 20px;
}
</style>